declare global {
  interface Window {
    env: any;
  }
}

export const env: any = { ...process.env, ...window.env };
